const ROLES_CONF = {
  "admin:admin": { exactRole: "admin", routeBase: "/app" },
  "admin:billing_partner": { exactRole: "bp", routeBase: "/app" },
  "admin:customer_success_executive": { exactRole: "cse", routeBase: "/app" },
  "admin:customer_success_manager": { exactRole: "csm", routeBase: "/app" },
  "provider:behavioral": { exactRole: "behavioral", routeBase: "/app" },
  "provider:case_manager": { exactRole: "case_manager", routeBase: "/app" },
  "provider:pcp": { exactRole: "pcp", routeBase: "/app" },
  "provider:peer": { exactRole: "peer", routeBase: "/app" },
  "provider:prescribe": { exactRole: "prescribe", routeBase: "/app" },
  "system:workflow": { exactRole: "workflow", routeBase: "/app" },
  "user:patient": { exactRole: "patient", routeBase: "/app" },
};

export const admin_admin = "admin:admin";
export const admin_bp = "admin:billing_partner";
export const admin_cse = "admin:customer_success_executive";
export const admin_csm = "admin:customer_success_manager";
export const provider_behavioral = "provider:behavioral";
export const provider_case_manager = "provider:case_manager";
export const provider_pcp = "provider:pcp";
export const provider_peer = "provider:peer";
export const provider_prescribe = "provider:prescribe";
export const system_workflow = "system:workflow";
export const user_patient = "user:patient";

export const adminRoute = "/app";
export const patientRoute = "/app";
export const providerRoute = "/app";

//eventually there should not be any group specific routes
export const baseRoute = "/app";

export default ROLES_CONF;
